import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Blade, Input, Button, ProgressIndicator } from 'rhombus-react';

import useActiveCreative from 'hooks/useActiveCreative';
import { closeModal } from 'reducers/Modal';
import CreativesTable from 'widgets/table/CreativesTable';
import { copyToClipboard, labelWithCount, safeDecodeURIComponent } from 'utils/common';
import { shouldDisplayAction } from 'utils/CreativeActions';
import { bulkStatusChange } from 'reducers/Creatives';
import { addNotification } from 'reducers/Notifications';

import './RejectCreatives.css';

export default function RejectCreatives(props) {
	const { creatives = [], libraryId } = props
		, dispatch = useDispatch()
		, user = useSelector(state => state.you)
		, rejectableCreatives = creatives.filter(creative => shouldDisplayAction.reject(user, creative))
		, pluralize = `${creatives.length > 1 ? 's' : ''}`
		, [rejectReason, setRejectReason] = useState("")
		, [isSubmitting, setIsSubmitting] = useState(false);

	let modalTitle;

	if(creatives.length === 0) {return null;}

	useActiveCreative(creatives[0].id);

	if(creatives.length > 1) {
		modalTitle = `Reject Creative - ${creatives.length} Creatives`;
	} else {
		modalTitle = `Reject Creative - ${safeDecodeURIComponent(creatives[0].name)}`;
	}

	const renderContent = () => {
		return (
			<div className="reject-creative-content">
				<ProgressIndicator isLoading={isSubmitting} />
				<p className="reject-creative-heading">
					<strong>State the Reason for Rejecting the Selected Creative{pluralize}</strong>
				</p>
				<div className="table-container">
					<CreativesTable className="reject-creatives-table" shouldLinkPreview={false} creatives={rejectableCreatives} />
				</div>
				<div className="reject-reason-container">
					<Input
						value={rejectReason}
						onChange={val => setRejectReason(val)}
						type="textarea"
						placeholder={`State the Reason for Rejecting the Selected Creative${pluralize}...`}
					/>
				</div>
			</div>
		);
	};

	const onClose = () => {
		dispatch(closeModal());
	};

	const onSubmit = () => {
		setIsSubmitting(true);
		return dispatch(bulkStatusChange({
			status: 'reject',
			libraryId,
			creativeIds: creatives.map(creative => creative.id),
			reason: rejectReason,
		})).then((resp) => {
			setIsSubmitting(false);
			if(resp?.success) {return onClose();}
		});
	};

	const handleCopy = () => {
		const names = creatives.map(creative => creative.name).join("\n");

		copyToClipboard(names)
			.then(() => {
				dispatch(addNotification({
					type: "success",
					messageHeader: "Copy Names",
					message: "Creative Names Copied",
				}));
			});
	};

	const renderFooter = () => {
		return (
			<>
				<Button key="cancel" className="button-cancel" theme="grey" disabled={isSubmitting} onClick={onClose}>Cancel</Button>
				<div className="right-buttons">
					<Button key="copy" onClick={handleCopy}>Copy Names</Button>
					<Button key="reject" theme="red" disabled={!rejectReason || isSubmitting} onClick={onSubmit}>
						{labelWithCount(`Reject Creative${pluralize}`, creatives.length)}
					</Button>
				</div>
			</>
		);
	};

	return (
		<Blade
			type="modal"
			setAppTitle={false}
			className="reject-creative"
			title={modalTitle}
			allowFullScreen={false}
			xclose
			bladeProps={{ verticallyCenter: true }}
			onClose={onClose}
			renderContent={renderContent}
			renderFooter={renderFooter}
		/>
	);
}

